"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatedGeneralDatetime = exports.getFormatedGeneralDate = exports.getFormattedEventDuration = exports.months = void 0;
exports.months = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    fi: ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu']
};
/**
 * Returns date object in 12hr (AM/PM) or 24h format based on locale
 *
 * @param d Date
 * @param locale string
 * @returns 2:00PM / 14:00
 */
const getLocaleFormatedTime = function formatAMPM(d, locale, keepEET) {
    if (locale != 'fi' && locale != 'en')
        locale = 'en';
    const timezone = keepEET ? 'Europe/Helsinki' : undefined;
    const formatedTime = new Date(d).toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit', timeZone: timezone });
    return formatedTime;
};
const getDayName = (date, locale, short, keepEET, end) => {
    const timezone = keepEET ? 'Europe/Helsinki' : undefined;
    const dayName = new Date(date).toLocaleDateString(locale, { weekday: short ? 'short' : 'long', timeZone: timezone });
    return end ? dayName : dayName[0].toUpperCase() + dayName.slice(1);
};
const getFormattedEventDuration = (startDate, endDate, locale, hideTime, keepEET) => {
    const eventStartDate = (0, exports.getFormatedGeneralDate)(startDate, locale, keepEET);
    const eventEndDate = (0, exports.getFormatedGeneralDate)(endDate, locale, keepEET);
    const eventStartTime = getLocaleFormatedTime(startDate, locale, keepEET);
    const eventEndTime = getLocaleFormatedTime(endDate, locale, keepEET);
    if (eventStartDate === eventEndDate) {
        const eventStartDateTime = hideTime ? `${getDayName(startDate, locale, true, keepEET, false)} ${eventStartDate}`
            : `${getDayName(startDate, locale, true, keepEET, false)} ${eventStartDate} ${locale === 'fi' ? 'klo' : 'at'} ${eventStartTime}`;
        return hideTime ? eventStartDateTime : `${eventStartDateTime} - ${eventEndTime}`;
    }
    const eventStartDateTime = hideTime ? `${getDayName(startDate, locale, true, keepEET, false)} ${eventStartDate}`
        : `${getDayName(startDate, locale, true, keepEET, false)} ${eventStartDate} ${locale === 'fi' ? 'klo' : 'at'} ${eventStartTime}`;
    return hideTime ? `${eventStartDateTime} - ${getDayName(endDate, locale, true, keepEET, true)} ${eventEndDate}`
        : `${eventStartDateTime} - ${getDayName(endDate, locale, true, keepEET, true)} ${eventEndDate} ${locale === 'fi' ? 'klo' : ','} ${eventEndTime}`;
};
exports.getFormattedEventDuration = getFormattedEventDuration;
/**
*Formats date based on locale
*8 May 2022 / 8.9.2022
*
* @param date
* @param locale (fi/en)
* @param keepEET (boolean to keep time in EET)
* @returns
*/
const getFormatedGeneralDate = (date, locale, keepEET) => {
    if (locale != 'fi' && locale != 'en')
        locale = 'en';
    const timezone = keepEET ? 'Europe/Helsinki' : undefined;
    const datevalue = locale === 'fi' ?
        new Date(date).toLocaleDateString(locale, { timeZone: timezone })
        : new Date(date).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric', timeZone: timezone });
    return datevalue !== 'Invalid Date' ? datevalue : '';
};
exports.getFormatedGeneralDate = getFormatedGeneralDate;
/**
 * Formats date & time based on locale
 * 8 May 2022 at 02:00PM / 8.9.2022 klo 14.00
 *
 * @param date
 * @param locale (fi/en)
 * @param keepEET (boolean to keep time in EET)
 * @returns
 */
const getFormatedGeneralDatetime = (date, locale, keepEET) => {
    if (locale != 'fi' && locale != 'en')
        locale = 'en';
    const timezone = keepEET ? 'Europe/Helsinki' : undefined;
    try {
        const newDate = new Date(date);
        const formatedDate = locale === 'fi' ?
            newDate.toLocaleDateString(locale, { timeZone: timezone })
            : newDate.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric', timeZone: timezone });
        const formatedTime = getLocaleFormatedTime(date, locale, keepEET);
        const divider = locale === 'fi' ? ' klo ' : ' at ';
        return formatedDate + divider + formatedTime;
    }
    catch (_a) {
        console.error('invalid date');
        return '';
    }
};
exports.getFormatedGeneralDatetime = getFormatedGeneralDatetime;
